import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';

const ProgressSteps = ({ steps = [], currentStep, className = '' }) => {
  const getCurrentStepIndex = () => {
    return steps.findIndex(step => step.id === currentStep);
  };

  const currentIndex = getCurrentStepIndex();

  return (
    <div className={`w-full ${className}`}>
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const isCompleted = index < currentIndex;
          const isCurrent = index === currentIndex;

          return (
            <React.Fragment key={step.id}>
              <div className="flex flex-col items-center">
                {/* Step Circle */}
                <motion.div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center
                    border-2 transition-all duration-300
                    ${isCompleted 
                      ? 'bg-pragyavan-gold border-pragyavan-gold text-pragyavan-brown' 
                      : isCurrent
                      ? 'bg-pragyavan-brown border-pragyavan-brown text-pragyavan-gold'
                      : 'bg-white border-warm-gray/30 text-warm-gray'
                    }
                  `}
                  whileHover={{ scale: 1.05 }}
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 30 }}
                >
                  {isCompleted ? (
                    <Check className="w-5 h-5" />
                  ) : (
                    <span className="text-sm font-medium">{index + 1}</span>
                  )}
                </motion.div>

                {/* Step Label */}
                <div className="mt-2 text-center max-w-24">
                  <p className={`
                    text-xs font-medium
                    ${isCurrent ? 'text-pragyavan-brown' : 'text-warm-gray'}
                  `}>
                    {step.label}
                  </p>
                  {step.description && (
                    <p className="text-xs text-warm-gray/70 mt-1">
                      {step.description}
                    </p>
                  )}
                </div>
              </div>

              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 mx-4 mt-5">
                  <motion.div
                    className={`
                      h-0.5 transition-all duration-500
                      ${index < currentIndex 
                        ? 'bg-pragyavan-gold' 
                        : 'bg-warm-gray/20'
                      }
                    `}
                    initial={{ scaleX: 0 }}
                    animate={{ scaleX: 1 }}
                    transition={{ delay: index * 0.2 }}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Current Step Info */}
      {steps[currentIndex] && (
        <motion.div
          key={currentStep}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-6 text-center"
        >
          <h3 className="text-lg font-semibold text-pragyavan-brown">
            {steps[currentIndex].label}
          </h3>
          {steps[currentIndex].description && (
            <p className="text-warm-gray mt-1">
              {steps[currentIndex].description}
            </p>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default ProgressSteps;